import {
  SchClearance, SchGrade, SchOrganizations, SchOrganizationType, SchResources, SchMinPermPos,
  SchScheduleItem, SchScheduleItemStatus, SchScheduleItemType, SchTravelRequests, SchTravelRequestLegs, SchTravelRequestBags
} from "../../../models";
import { GanttSchedule } from 'src/app/containers/scheduling/aims-scheduler/aims-scheduler-gantt.component';
import * as moment from 'moment-mini';

export class Organizations extends SchOrganizations {
  constructor() {
    super();
    this.organizationId = 0;
    this.organizationName = null;
    this.govBilled = false;
    this.companyBilled = false;
    this.organizationTypeId = null;
    this.address = null;
    this.email = null;
    this.contactPhone = null;
  }
}

export class OrganizationType extends SchOrganizationType {
  constructor() {
    super();
    this.organizationTypeId = 0;
    this.organizationTypeCode = null;
  }
}

export class Resources extends SchResources {
  constructor() {
    super();
    this.resourceId = 0;
    this.oldScheduledIds = null;
    this.active = true;
    this.lastName = null;
    this.firstName = null;
    this.middleName = null;
    this.fullName = null;
    this.gradeId = null;
    this.organizationId = null;
    this.clearanceId = null;
    this.genderTypeId = null;
    this.isVip = false;
    this.isCarrier = false;
    this.createdOn = null;
    this.createdById = null;
    this.modifiedOn = null;
    this.modifiedById = null;
  }
}


export class ScheduleItem extends SchScheduleItem {
  constructor(ganttSch: GanttSchedule = null) {
    super();
    if (ganttSch == null) {
      this.scheduleItemId = 0;
      this.scheduleItemStart = null;
      this.scheduleItemEnd = null;
      this.scheduleItemStatusId = null; //ScheduleItemStatusEnum.approved;
      this.scheduleItemTypeId = null;
      this.siteId = null;
      this.employeeId = null;
      this.resourceId = null;
      this.reliefForId = null;
      this.overhireJtId = null;
      this.oanumber = null;
      this.copaId = null;
      this.travelArrangeReq = false;
      this.govBilled = false;
      this.companyBilled = false;
      this.restrictedAccess = false;
      this.restrictedAreaPhotography = false;
      this.meals = false;
      this.teraccess = false;
      this.classifiedAccess = false;
      this.comsecaccess = false;
      this.escortOnly = false;
      this.billeting = false;
      this.notes = null;
      this.createdOn = null;
      this.createdById = null;
      this.siteArrivalNoticeRequired = false;
      this.confirmArrival = null;
      this.confirmDeparture = null;
      this.carrierId = null;
      this.flightNumber = null;
      this.arrival = null;
      this.departure = null;
      this.arrivalCarrierSchItemId = null;
      this.departureCarrierSchItemId = null;
      this.purpose = null;
      this.firearmRequest = false;
      this.radarDowntime = false;
      this.transToTopCamp = false;
      this.modifiedById = null;
    }
    else {
      this.scheduleItemId = ganttSch.id;
      this.scheduleItemStatusId = ganttSch.scheduleItemStatusId;
      this.scheduleItemTypeId = ganttSch.scheduleItemTypeId;
      this.siteId = ganttSch.siteId;
      this.employeeId = ganttSch.employeeId;
      this.resourceId = ganttSch.resourceId;
      this.reliefForId = ganttSch.reliefForId;
      this.overhireJtId = ganttSch.overhireJtId;
      this.oanumber = ganttSch.oanumber;
      this.copaId = ganttSch.copaId;
      this.scheduleItemStart = moment(ganttSch.start).toDate();
      this.scheduleItemEnd = moment(ganttSch.end).toDate();
      this.travelArrangeReq = ganttSch.travelArrangeReq;
      this.govBilled = ganttSch.govBilled;
      this.companyBilled = ganttSch.companyBilled;
      this.restrictedAccess = ganttSch.restrictedAccess;
      this.meals = ganttSch.meals;
      this.teraccess = ganttSch.teraccess;
      this.classifiedAccess = ganttSch.classifiedAccess;
      this.comsecaccess = ganttSch.comsecaccess;
      this.escortOnly = ganttSch.escortOnly;
      this.restrictedAreaPhotography = ganttSch.restrictedAreaPhotography
      this.billeting = ganttSch.billeting;
      this.notes = ganttSch.notes;
      this.createdOn = ganttSch.createdOn;
      this.createdById = ganttSch.createdById;
      this.siteArrivalNoticeRequired = ganttSch.siteArrivalNoticeRequired;
      this.schTravelRequestLegs = ganttSch.schTravelRequestLegs;
      this.confirmArrival = ganttSch.confirmArrival;
      this.confirmDeparture = ganttSch.confirmDeparture;
      this.clearanceId = ganttSch.clearanceId;
      this.carrierId = ganttSch.carrierId;
      this.flightNumber = ganttSch.flightNumber;
      this.arrival = ganttSch.arrival;
      this.departure = ganttSch.departure;
      this.arrivalCarrierSchItemId = ganttSch.arrivalCarrierSchItemId;
      this.departureCarrierSchItemId = ganttSch.departureCarrierSchItemId;
      this.purpose = ganttSch.purpose;
      this.firearmRequest = ganttSch.firearmRequest;
      this.schFirearms = ganttSch.schFirearms;
      this.radarDowntime = ganttSch.radarDowntime;
      this.transToTopCamp = ganttSch.transToTopCamp;
      this.modifiedById = ganttSch.modifiedById;
    }
  }
  clearanceId: number = null;
  reliefForJtId: number = null;
  jtWsId: number = null;

}

export class ScheduleItemStatus extends SchScheduleItemStatus {
  constructor() {
    super();
    this.scheduleItemStatusId = 0;
    this.scheduleItemStatus = null;
  }
}

export class ScheduleItemType extends SchScheduleItemType {
  constructor() {
    super();
    this.scheduleItemTypeId = 0;
    this.scheduleItemType = null;
    this.isEmployeeSiType = true;
    this.govBilledDefault = false;
    this.companyBilledDefault = false;
   this.mealsDefault = true;
    this.billetingDefault = true;
    this.color = '#FCF4A3';
    this.icon = null;
  }
}

export class Clearance extends SchClearance {
  constructor() {
    super();
    this.clearanceId = 0;
    this.clearanceName = null;
  }
}

export class Grade extends SchGrade {
  constructor() {
    super();
    this.gradeId = 0;
    this.grade = null;
    this.rank = null;
  }
}

export class MinPermPos extends SchMinPermPos {
  constructor() {
    super();
    this.minPermPosId = 0;
    this.siteId = 0;
    this.jobTitleId = 0;
    this.minimum = 0;
  }
}

export class TravelRequest extends SchTravelRequests {
  constructor() {
    super();
    this.travelRequestId;
    this.travelRequestStatusId;
    this.requestedOn;
    this.employeeId;
    this.resourceId;
    this.requestedById;
    this.approvedById;
    this.approvedOn;
    this.qualityControlledById;
    this.qualityControlledOn;
    this.nonRefundableAuth;
    this.charter;
    this.groundTime;
    this.lodgingAuthTypeId;
    this.rentalCarAuthTypeId;
    this.travelRequestComments;
    this.createdById;
    this.createdOn;
    this.modifiedById;
    this.modifiedOn;
    this.confirmedOn;
    this.submittedOn;
  }
  travelWeight: number = 0;
  militaryTransportAuthorized: boolean = false;
}

export class TravelRequestLegs extends SchTravelRequestLegs {
  constructor() {
    super();
    this.travelRequestLegId = 0;
    this.travelRequestId = 0;
    this.travelFromId = null;
    this.travelToId = null;
    this.travelOn = null;
    this.departId = null;
    this.arriveId = null;
    this.travelLeg = null;
    this.militaryNonSupported = false;
    this.travelerTypeId = null;
    this.taskCodeId = null;
    this.oanumber = null;
    this.scheduleItemId = null;
  }
}

export class TravelRequestBags extends SchTravelRequestBags {
  constructor() {
    super();
    this.travelRequestBagId = 0;
    this.travelRequestId = 0;
    this.travelRequestBagTypeId = 3;
    this.weight = 50;
    this.oversize = false;
  }
}
